$(document).ready(function(){
  var currentPage 			= window.location.pathname;
  var on92PackIndex 		= currentPage.indexOf("collections/92-pack");
  var onDecoPackIndex 		= currentPage.indexOf("collections/deco-pack");
  var onUrokoPackIndex 		= currentPage.indexOf("collections/uroko-pack");
  var onObsidianPackIndex 	= currentPage.indexOf("collections/obsidian-pack");
  var onCollection			= currentPage.indexOf("collections");
  var onCustomPage 			= currentPage.indexOf("pages");
  var inPack				= currentPage.indexOf("-pack");
  
  // Fire dropdown interaction picker
  mainNavInteraction();   
  $(window).resize(mainNavInteraction);
  
  // Hide / show main nav on small screens
  $(document).on('click', '.hamburger', function(e){
    $('.header .main-nav').toggle();
  }); 
  
  // Add active class to Packs and Lookbook main nav items if in those sections
  if ((onCollection != -1) && (inPack != -1)){
  	$('.main-nav > ul > li:nth-child(2)').addClass('active');
  }  
  if ((onCustomPage != -1) && (inPack != -1)){
  	$('.main-nav > ul > li:nth-child(4)').addClass('active');
  }  
  
  // Hide / show search overlay
  $(document).on('click', '.search-button', function(e){
	$('.search-overlay').velocity('fadeIn', { duration: 300 }, 'easeOutQuart');
    $('body').css('overflow', 'hidden');
  });
  
   $(document).on('click', '.search-overlay .close', function(e){
	$('.search-overlay').velocity('fadeOut', { duration: 300 }, 'easeOutQuart');
    $('body').css('overflow', 'visible');
  });	
  
  // Home page animation
  $('.template-index .loading-badge').velocity('fadeIn', { duration: 800 }, 'easeOutQuart');
  
  // Add masthead image to the packs index views
  if (on92PackIndex !=  -1) {
    $('#masthead-image-target').before('<h1 class="pack-landing-page-header">\'92 Pack</h1><img class="masthead" src="//dailybreadpa.com/cdn/shop/t/24/assets/92-pack-masthead.jpg?v=5708688242549753891793827998" alt="92 Pack" >');
  } else if (onDecoPackIndex !=  -1){
    $('#masthead-image-target').before('<h1 class="pack-landing-page-header">Deco Pack</h1><img class="masthead" src="//dailybreadpa.com/cdn/shop/t/24/assets/deco-pack-masthead.jpg?v=47349553187058319121793827998" alt="Deco Pack" >');
  } else if (onUrokoPackIndex !=  -1){
    $('#masthead-image-target').before('<h1 class="pack-landing-page-header">Uroko Pack</h1><img class="masthead" src="//dailybreadpa.com/cdn/shop/t/24/assets/uroko-pack-masthead.jpg?v=102747995090155984791793827998" alt="Uroko Pack" >');      
  } else if (onObsidianPackIndex !=  -1){
    $('#masthead-image-target').before('<h1 class="pack-landing-page-header">Obsidian Pack</h1><img class="masthead" src="//dailybreadpa.com/cdn/shop/t/24/assets/obsidian-pack-masthead.jpg?v=71286065406852918101793827998" alt="Uroko Pack" >');      
  }

  // Create and fade in/out shopping lookbook button and remove top footer margin if on lookbook
  if ((onCustomPage != -1) && (inPack != -1)){
    var collectionURL = currentPage.replace('pages', 'collections') 
     
    $('.lookbook').append('<a class="shop-lookbook-button" href="' + collectionURL + '">Shop This Lookbook</a>').append('<div id="shop-lookbook-button-waypoint"></div>');
  	$('footer').css('margin-top', '0'); 
      
    initWaypoint();
  } 
      
  function initWaypoint() {
    
    var waypoint = new Waypoint({
      element: document.getElementById('shop-lookbook-button-waypoint'),
      handler: function(direction) {
        if (direction == 'down') {
          $('.shop-lookbook-button').velocity('fadeIn', { duration: 300 }, 'easeOutQuart');        
        } else {
          $('.shop-lookbook-button').velocity('fadeOut', { duration: 300 }, 'easeOutQuart');                
        }
      }
    })      
  }    
                                           
  // About page masthead animations
  $('.about .masthead').velocity('fadeIn', 800, function() {
     $('.about .badge').velocity('fadeIn', 1200, 'easeOutQuart');
  });
      
  
  // Fade in collections 
  $('body.template-collection').delay(1000).velocity('fadeIn', 2000, 'easeOutQuart'); 
});

// Set the dropdown interaction as click for phones and tablets; set it as hover for larger screens
var mainNavInteraction = function(){
  if (Modernizr.mq('(min-width: 1025px)')) {
  	$('.header .main-nav').show();
  }
  
  if (Modernizr.mq('(max-width: 1024px)')) {    
    $(document).on('click', '.has-dropdown i', function(e){
      	$(this).next().toggle();
    });       
  } else if (Modernizr.mq('(min-width: 1025px)')) { 
    $( ".has-dropdown" ).hover(
      function() {
        $(this).find('.dropdown').show();
      }, function() {
        $(this).find('.dropdown').hide();
      }
    );     
  }
} 

